module.exports = __webpack_public_path__ + "static/img/Bags PU products application horizontal_desktop.cd395e45.jpg";